'use strict'

let canvansTool = {}
let HEIGHT = 60;
let LINE_HEIGHT = 30

let getPixelRatio = (context)=>{
    var backingStore = context.backingStorePixelRatio
        || context.webkitBackingStorePixelRatio
        || context.mozBackingStorePixelRatio
        || context.msBackingStorePixelRatio
        || context.oBackingStorePixelRatio
        || context.backingStorePixelRatio || 1;
    return (window.devicePixelRatio || 1) / backingStore;
}

let setText = (itemId, str, logoText, contentHeight=HEIGHT) => {
    let clientWidth = document.documentElement.clientWidth-30;
    let can = document.createElement('canvas')
    let ratio = getPixelRatio(can)
    can.width = clientWidth*ratio
    can.height = contentHeight*ratio
    can.style.width = clientWidth + "px";
    can.style.height = contentHeight + "px";
    let cans = can.getContext('2d')
    cans.scale(ratio,ratio);
    cans.font = 'normal 500 15px Vedana'
    cans.fillStyle = 'rgba(0, 0, 0)'
    cans.textAlign = 'left'
    cans.textBaseline = 'Middle'

    let maxWidth = can.width/ratio
    let lineHeight = LINE_HEIGHT;
    let line = '';
    let x = 0;
    let y = 25;
    let arrText = str.split('');

    for (let n = 0; n < arrText.length; n++) {
        let testLine = line + arrText[n];
        let metrics = cans.measureText(testLine);
        let testWidth = metrics.width;
        if (testWidth > maxWidth && n > 0) {
            cans.fillText(line, x, y);
            line = arrText[n];
            y += lineHeight;
        } else {
            line = testLine;
        }
    }
    cans.fillText(line, x, y);
    drawLogo(cans, logoText, can.width, can.height)

    let parent = document.getElementById(itemId)
    let div = document.createElement('div')
    div.id = 'img_'+itemId
    div.style.width = can.width/ratio-30+'px'
    div.style.height = can.height/ratio + 'px'
    div.style.margin = '5px 15px 0 15px'
    // div.style.padding = '30px 0 0 0'
    div.style.background = 'url(' + can.toDataURL('image/png') + ')left top no-repeat'
    div.style.backgroundSize = "contain"
    parent.appendChild(div)

}
let drawLogo = (cans, logoText, dWidth, dHeight) => {
    let count = logoText.length;
    let wordSize = 24;
    let height = HEIGHT-2
    let width = count * wordSize+40;

    cans.lineWidth = 2;
    cans.strokeStyle =  'rgba(255, 0, 0, .4)'
    cans.rotate(10 * Math.PI / 180)
    let x = 10//(dWidth-width)/2
    let y = -15//(dHeight-height)/2 -40
    cans.strokeRect(x, y ,width, height)
    cans.font = 'normal 500 '+wordSize+'px Vedana'
    cans.fillStyle = 'rgba(255, 0, 0, .4)'
    cans.fillText(logoText, (x+(width-wordSize*count)/2), (y+(height+wordSize-10)/2))
}
let remove = (itemId)=>{
    let parent = document.getElementById(itemId);
    if (parent !== null){
        while(parent.hasChildNodes())
        {
            parent.removeChild(parent.firstChild);
        }
    }

}
// 该方法只允许调用一次
canvansTool.drawContent = (itemId, article, logoText) => {
    remove(itemId)
    setText(itemId, article.article_content_visible, logoText)
    if(article.article_content_payed===undefined){
        setText(itemId, "暂未购买，点击查看内容继续", logoText)
    }
    else{
        setText(itemId, article.article_content_payed, logoText, HEIGHT+30)
    }
}


export default canvansTool
